module.exports = __webpack_public_path__ + "static/img/04.96acdeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/04.png
// module id = kULL
// module chunks = 1